// libs
import escape from 'lodash/escape';
import isEmpty from 'lodash/isEmpty';

// constants
import { QUERY_STRING, PAGE_CONTEXT, DEFAULT_PREFIX_FOR_SLUG } from './constants';

export const getPageName = (search: Location['search'], slug: string) => {
  const urlSearch = new URLSearchParams(search);

  const pageTypeUnSafe = urlSearch.get(QUERY_STRING.PAGE_TYPE);
  let pageType = isEmpty(pageTypeUnSafe) || pageTypeUnSafe === 'null' ? '' : escape(pageTypeUnSafe);

  if (!pageType) {
    pageType = DEFAULT_PREFIX_FOR_SLUG + escape(slug);
  }

  const hasPageVariation = urlSearch.get(QUERY_STRING.PAGE_VARIATION) === '1';

  const mwebPageName = hasPageVariation ? `${pageType}${PAGE_CONTEXT.MWEB}` : pageType;
  const dwebPageName = hasPageVariation ? `${pageType}${PAGE_CONTEXT.DWEB}` : pageType;

  return { mwebPageName, dwebPageName };
};
